export class SimpleUser {
    constructor(
        public id: number,
        public name: string
    ){}
}
